<template>
    <div class="debitCard">
        <h3>{{'components/settings/add-new-card.submit-card' | trans}}</h3>
        <new-card
            :submit-button-label="'components/settings/add-new-card.submit-card' | trans"
            @submitCard="submitCard"
            :loading="isProcessingSavingNewCard"
            ref="newCard"
        >
            <div class="notificationContainer" v-bind:class="{ hide: jurisdiction === 'DE' || jurisdiction === '' }">
                <img src="/assets/img/info.svg">
                <span>{{'components/settings/add-new-card.this-card-will-be-used-for-monthly-payments' | trans}}</span>
            </div>

            <div class="inputCheckboxWrap" v-if="homeAddress">
                <input v-model="addressMatchToReResidentialAddress" id="address_match" type="checkbox" name="amount"
                       value="installment">
                <label class="radio" for="address_match"></label>
                <span @click="addressMatchToReResidentialAddress = !addressMatchToReResidentialAddress"
                      class="text">{{'components/settings/add-new-card.my-home-address-matches-my-payment-address' | trans}}.</span>
            </div>
            <div>
                <div v-if="!addressMatchToReResidentialAddress">
                    <br>
                    <PulseLoader v-if="addressSelectLoading" size="8px" color="#00B2FF"/>
                    <div class="selectWrap" :class="{'hasError' : !addressError}">
                        <v-select
                            :options="optionAddresses"
                            v-model="selectedAddress"
                            :reduce="address => address.value"
                            :placeholder="'components/settings/add-new-card.select-address' | trans"
                            class="formSelect"
                        />
                        <div class="error" v-if="!addressError">
							{{'components/settings/add-new-card.address-is-required' | trans}}
                        </div>
                    </div>
                </div>
            </div>

        </new-card>
    </div>
</template>

<script>

    import newCard from './NewCard';
    import vSelect from 'vue-select';
    import {mapState, mapActions} from 'vuex';

    export default {
        components: {newCard, vSelect},
        data: () => {
            return {
                addressMatchToReResidentialAddress: true,
                addressSelectLoading: false,
                selectedAddress: null,
                addressError: true,
                isProcessingSavingNewCard: false,
				jurisdiction : ''
            }
        },
        methods: {
            ...mapActions(['addNewCard', 'getUserInfo', 'addMessage']),
            submitCard: function (payload) {
                if (this.addressMatchToReResidentialAddress) {
                    this.selectedAddress = this.user.addresses.residentialAddressId
                }

                if (!this.selectedAddress) {
                    console.log('address not assigned');
                    this.addressError = false;
                    return;
                }

                let data = {
                    name: payload.nameOnCard,
                    card_number: payload.pan,
                    expiry_date_month: payload.month,
                    expiry_date_year: payload.year,
                    cvv: payload.cvv,
                    addressMatchToReResidentialAddress: this.addressMatchToReResidentialAddress,
                    selectedAddressID: this.selectedAddress ? this.selectedAddress : null
                };

                this.isProcessingSavingNewCard = true;
                this.addNewCard(data)
                    .then(response => {
                        this.addMessage(response.data.messages);
                        return this.getUserInfo();
                    })
                    .then(response => {
                        this.$refs.newCard.resetForm();
                        this.selectedAddress = null;
                        this.addressMatchToReResidentialAddress= true;
                        this.addressError = false;

                        this.isProcessingSavingNewCard = false;
                    })
                    .catch(err => {
                        this.isProcessingSavingNewCard = false;
                        console.log(err)
                    });
            }
        },
        computed: {
            ...mapState(['addressBook', 'user']),
            optionAddresses: function () {
                let addresses = [];
                this.addressBook.forEach(function (address) {
                    addresses.push({
                        label: address.full_address,
                        value: address.id,
                    });
                });
                return addresses;
            },
            homeAddress: function () {
                if (!this.user || !this.user.addresses || !this.user.addresses.residentialAddressId) {
                    this.addressMatchToReResidentialAddress = false
                    return null;
                }
                return this.user.addresses.residentialAddressId
            }
        },
        watch: {
            selectedAddress: function (newVal) {
                if (newVal) {
                    this.addressError = true;
                } else {
                    this.addressError = false;
                }
            }
        },
		created() {
			this.getUserInfo().then((response) => {
				this.jurisdiction = this.user.jurisdiction;
			});
		}
    }


</script>
